import { render } from "./OutOfSquare.vue?vue&type=template&id=213a5c68&scoped=true"
import script from "./OutOfSquare.vue?vue&type=script&lang=js"
export * from "./OutOfSquare.vue?vue&type=script&lang=js"

import "./OutOfSquare.vue?vue&type=style&index=0&id=213a5c68&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213a5c68"]])

export default __exports__